import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "../../../../../client-utils/styled/index.js";
import { DOUBLE } from "../../../../../constants/numbers.consts.js";
import { coreComponentName } from "../../AppBar.consts.js";
import Box from "../../../../../components/atoms/Box/index.js";
import IconButtonGroup from "../../../../../components/atoms/IconButtonGroup/index.js";
import IconButton from "../../../../../components/atoms/IconButton/index.js";
import SearchBar from "../../../../../components/molecules/SearchBar/index.js";
import { searchDefaults } from "../../../../../translate/defaults/search.defaults.js";
import { titleDefaults } from "../../../../../translate/defaults/title.defaults.js";
const AppBarActionIcons = styled(Box, {
    name: coreComponentName,
    slot: "AppBarActionIcons",
})(({ theme }) => ({
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(DOUBLE),
}));
export const AppBarActionIconsComponent = ({ actionIcons, search, notifications, onOpenNotifications, translations, ...props }) => (_jsxs(AppBarActionIcons, { "data-testid": "AppBarActionIcons", ...props, children: [search && (_jsx(SearchBar, { translations: {
                placeholder: translations?.searchPlaceholder ?? searchDefaults.placeholder,
                moreResults: translations?.searchMoreResults ?? searchDefaults.moreResults,
            }, ...search })), _jsx(IconButtonGroup, { data: actionIcons ?? [] }), notifications && (_jsx(IconButton, { title: translations?.notificationsTitle ?? titleDefaults.notifications, type: "bell", badge: notifications?.badge, onClick: onOpenNotifications, "data-testid": "AppBarActionIconsNotifications", "data-tourid": "AppBarActionIconsNotifications", iconProps: {
                sx: {
                    color: ({ vars }) => vars.palette.surface.on,
                },
            } }))] }));
export default AppBarActionIconsComponent;
